// removed by extract-text-webpack-plugin
module.exports = {"vpDescriptionContainer":"vpDescriptionContainer___1AliP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/CampaignDescription.module.less
// module id = 3426
// module chunks = 30